import { render, staticRenderFns } from "./replaceMobile.vue?vue&type=template&id=6c2fdf72&scoped=true"
import script from "./replaceMobile.vue?vue&type=script&lang=js"
export * from "./replaceMobile.vue?vue&type=script&lang=js"
import style0 from "./replaceMobile.vue?vue&type=style&index=0&id=6c2fdf72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2fdf72",
  null
  
)

export default component.exports